











import Vue from "vue";
import Component from "vue-class-component";
import { Mixins, Watch } from "vue-property-decorator";
import { ChartOverlayConfigItemMixin } from "./chart-overlay-config-item.mixin";
import { get } from "lodash";
import { UPDATE_CHART_OVERLAY } from "../../../../store/chart-overlay.module/mutations/update-chart-overlay.mutation";

@Component({
  components: {
    PureRadioSlide: () => import("../../pure-config/PureRadioSlide.vue"),
  },
})
export default class OverlayRadioSlideConfig extends Mixins(
  ChartOverlayConfigItemMixin,
) {
  private selected = "";

  @Watch("activeOverlayId", { immediate: true })
  onSelectedOverlayChange(id: string) {
    const metadata: ChartOverlayMetadata = this.getOverlayMetadataById(id);
    if (metadata) {
      const v = get(metadata, this.setting.path);
      this.selected = v || this.selected;
    }
  }

  handleChange(value) {
    this.$stock.commit(UPDATE_CHART_OVERLAY, {
      id: this.activeOverlayId,
      path: this.setting.path,
      value,
    });
  }
}
